import React, { useState } from 'react';
import { Button, Form, Modal } from 'react-bootstrap';
import axios from 'axios';
import toast from 'react-hot-toast';
import { API_BASE_URL, getBearerToken } from '../../functions';

const UmrahUpdatePNR = ({ show, setShow, selectedBooking }) => {
  const handleClose = () => setShow(false);
  const [loading, setLoading] = useState(false);
  const [pnr, setPnr] = useState(selectedBooking?.pnr || '');

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!pnr.trim()) {
      toast.error('Please enter a PNR');
      return;
    }

    setLoading(true);
    const tid = toast.loading('Updating PNR...');
    
    try {
      const response = await axios.post(`${API_BASE_URL}/umrah-booking/pnr`, {
        booking_id: selectedBooking?.id,
        pnr: pnr.trim()
      }, {
        headers: {
          'Authorization': `Bearer ${getBearerToken()}`
        }
      });

      if (response.data.status) {
        toast.success('PNR updated successfully');
        handleClose();
        setTimeout(() => {
          window.location.reload();
        }, 2000);
      } else {
        toast.error(response.data.message || 'Failed to update PNR');
      }
    } catch (error) {
      console.error('Error updating PNR:', error);
      toast.error(error.response?.data?.message || 'Failed to update PNR');
    } finally {
      setLoading(false);
      toast.dismiss(tid);
    }
  };

  return (
    <Modal show={show} onHide={handleClose} centered>
      <Modal.Header closeButton>
        <Modal.Title>{selectedBooking?.pnr ? 'Update PNR' : 'Add PNR'}</Modal.Title>
      </Modal.Header>
      <Form onSubmit={handleSubmit}>
        <Modal.Body>
          <div className="mb-3">
            <label className="form-label">Booking ID: {selectedBooking?.id}</label>
          </div>
          <div className="mb-3">
            <label className="form-label">Package: {selectedBooking?.umrah_package?.title}</label>
          </div>
          <Form.Group className="mb-3">
            <Form.Label>PNR Number</Form.Label>
            <Form.Control
              type="text"
              value={pnr}
              onChange={(e) => setPnr(e.target.value)}
              placeholder="Enter PNR number"
              required
            />
          </Form.Group>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose} disabled={loading}>
            Cancel
          </Button>
          <Button variant="primary" type="submit" disabled={loading}>
            {loading ? 'Updating...' : (selectedBooking?.pnr ? 'Update PNR' : 'Add PNR')}
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
};

export default UmrahUpdatePNR;